export const enum ELocationTags {
  DEFECT_LOCATION = 'defectLocation'
}

export type TDefectLocationParams = {
  district: string;
};
